<template>
  <RouterView />
</template>

<script>
</script>

<style>
</style>
